export enum SourceName {
  dealer = 'dealer',
  mobile = 'mobile',
  agenda = 'agenda',
  fordpass = 'fordpass',
  web = 'web',
  others = 'others',
  perks = 'perks',
  mfa = 'myFordAccountURL',
  perksFordpass = 'perks-fordpass-ui'
};

export enum SourceAbbr {
  dealer = 'D',
  mobile = 'M',
  agenda = 'A',
  fordpass = 'F',
  web = 'W',
  others = 'O'
};

export enum SizeScreen {
  MOBILE = 480,
  IPAD = 1024
};

